<template>
    <div>
        <PageTitle :pages="pages" :title="titles.commercialList"/>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">{{title}}</h4>
                <Tab :currentTabComponent="tabs[0].component" :form="commercial" :show="showTab" :tabs="tabs"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Tab from '../../common/Tab';
    import PageTitle from '@/components/common/PageTitle';
    import {titles} from '../../../utils/general/titles';
    import {name} from '../../../utils/general/routers';
    import {commercial} from '../../shared/models/commercial';

    export default {
        components: {PageTitle, Tab},
        props: {
            showPageTitle: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                titles,
                showTab: true,
                title: titles.commercialAddExpression,
                pages: [],
                commercial: commercial(),
                tabs: [
                    {
                        name: 'Général',
                        component: 'commercial-form'
                    },
                    {
                        name: 'Clients',
                        component: 'clients-table'
                    }
                ]
            };
        },
        created() {
            if (this.$route.params.commercialItem) {
                this.$cookies.set('commercialItem', this.$route.params.commercialItem);
            }
            if (this.$cookies.isKey('commercialItem')) {
                this.title = titles.commercialDetailExpression;
                this.commercial = this.$cookies.get('commercialItem');
                this.showTab = true;
            } else {
                this.showTab = false;
            }

            this.tabSelected = this.tabs[0].component;
            this.pages.push(
                {
                    name: titles.network,
                    router: name.network,
                    active: false
                },
                {
                    name: titles.commercialList,
                    router: name.commercialList,
                    active: false
                },
                {
                    name: this.title,
                    router: null,
                    active: true
                }
            );
        }
    };
</script>
<style lang="scss" scoped>
    .met-pro-bg {
        background-image: url("../../../assets/images/pro.jpg");
        background-repeat: no-repeat;
        background-size: cover;
    }

    a {
        cursor: pointer;
    }

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .component-fade-enter, .component-fade-leave-to {
        opacity: 0;
    }

    .btn-standard-gradient {
        box-shadow: none;
    }
</style>
